// MapSales.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sqs from "../Sqs";
import BottomTabBar from "../components/BottomTabBar";
import AppButton from "../components/AppButton";

const MapSales = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("phone")) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="min-h-[100dvh] bg-gray-50 w-full flex flex-col pb-24 sm:pb-28">
      <div className="w-full max-w-4xl mx-auto flex-1 px-4 sm:px-5 pt-8 sm:pt-10">
        <AppButton
          variant="ghost"
          fullWidth={false}
          onClick={() => navigate("/user-settings")}
          className="mb-4"
        >
          ← Back
        </AppButton>
        <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-1">
          Map of Store Sales
        </h1>
        <p className="text-sm text-gray-500 mb-6">
          Visualize sales activity across your store layout
        </p>
        <div className="bg-white rounded-2xl border border-gray-100 p-4 sm:p-5 shadow-sm">
          <Sqs />
        </div>
      </div>
      <BottomTabBar />
    </div>
  );
};

export default MapSales;
